import { useRouter } from 'next/router';
import { useMemo } from 'react';

interface useConnectQueryReturn {
  backPathname: string;
  backAsPath: string;
  [key: string]: string;
}

export default function useConnectQuery(
  queries?: Record<string, any>
): useConnectQueryReturn {
  const router = useRouter();

  return useMemo(() => {
    const query = {
      backPathname: router.pathname,
      backAsPath: router.asPath,
    };
    for (let queryEntry of Object.entries(router.query)) {
      query[`savedQuery${queryEntry[0]}`] = queryEntry[1];
    }
    // We use this query for redirect for CheckAuth component
    if (queries) {
      for (let queryEntry of Object.entries(queries)) {
        query[`savedQuery${queryEntry[0]}`] = queryEntry[1];
      }
    }
    return query;
  }, [router.pathname, router.query, router.asPath]);
}
